<template>
  <div class="wrap">
    <div class="title">
      <span>{{ editTitle }}</span>
    </div>
    <div class="content">
      <el-form
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="ruleForm"
        size="small"
      >
        <el-row>
          <el-col>
            <div>30分钟以内视频</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item>
              <div>
                <span>每</span>
                <el-input
                  placeholder="请输入分钟值"
                  style="width:100px"
                  v-model="key1.value"
                  :key="key1.key"
                  required
                ></el-input>
                <span>分钟获得学分</span>
                <el-input
                  placeholder="请输入学分值"
                  style="width:100px"
                  v-model="key2.value"
                  :key="key2.key"
                ></el-input>
                <span>分</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <div>30分钟（含）以上视频</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item>
              <div>
                <span>每</span>
                <el-input
                  placeholder="请输入分钟值"
                  style="width:100px"
                  v-model="key3.value"
                  :key="key3.key"
                ></el-input>
                <span>分钟获得学分</span>
                <el-input
                  placeholder="请输入学分值"
                  style="width:100px"
                  v-model="key4.value"
                  :key="key4.key"
                ></el-input>
                <span>分，上限</span>
                <el-input
                  placeholder="请输入上限值"
                  style="width:100px"
                  v-model="key5.value"
                  :key="key5.key"
                ></el-input>
                <span>分</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="text-align: center;">
          <el-button @click="reset">重置</el-button>
          <el-button @click="$router.back()">返回</el-button>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { creditRuleUpdate, creditRuleInfo } from "@/api/creditRule";

export default {
  name: "editRule",
  data() {
    let validateNumber = (rule, value, callback) => {
      let reg = /(^[0-9]*[1-9][0-9]*)$/;
      if (!value || !reg.test(value)) {
        callback();
      } else {
        callback("请输入正整数值");
      }
    };
    let validateSmallNumber = (rule, value, callback) => {
      let reg = /^\d*\.{0,1}\d{0,2}$/;
      if (!value || !reg.test(value)) {
        callback();
      } else {
        callback("请输入正确的分值");
      }
    };
    return {
      editTitle: "编辑学分规则",
      rules: {
        key1: {
          value: [
            { required: true, validator: validateNumber, trigger: "blur" }
          ]
        },
        key2: {
          value: [
            { required: true, validator: validateSmallNumber, trigger: "blur" }
          ]
        },
        key3: {
          value: [
            { required: true, validator: validateNumber, trigger: "blur" }
          ]
        },
        key4: {
          value: [
            { required: true, validator: validateSmallNumber, trigger: "blur" }
          ]
        },
        key5: {
          value: [
            { required: true, validator: validateSmallNumber, trigger: "blur" }
          ]
        }
      },
      ruleForm: {
        creditRuleDetails: []
      },
      key1: {
        id: "",
        key: "1",
        value: ""
      },
      key2: {
        id: "",
        key: "2",
        value: ""
      },
      key3: {
        id: "",
        key: "3",
        value: ""
      },
      key4: {
        id: "",
        key: "4",
        value: ""
      },
      key5: {
        id: "",
        key: "5",
        value: ""
      },
      edituuid: "",
      resourceType: 0,
      deptId: "",
      showError: false
    };
  },
  created() {
    this.editTitle = "编辑学分规则";
    this.getDetail();
  },
  methods: {
    //获取数据
    getDetail: function() {
      this.edituuid = this.$route.query.id;
      creditRuleInfo(this.edituuid).then(res => {
        if (!res || res.code != 0) return;
        const { data } = res;
        const list = data.creditRuleDetails;
        if (list.length > 0) {
          let that = this;
          list.forEach(function(creditRuleDetail) {
            if (creditRuleDetail.ruleKey == that.key1.key) {
              that.key1.id = creditRuleDetail.uuid;
              that.key1.value = creditRuleDetail.ruleValue;
            } else if (creditRuleDetail.ruleKey == that.key2.key) {
              that.key2.id = creditRuleDetail.uuid;
              that.key2.value = creditRuleDetail.ruleValue;
            } else if (creditRuleDetail.ruleKey == that.key3.key) {
              that.key3.id = creditRuleDetail.uuid;
              that.key3.value = creditRuleDetail.ruleValue;
            } else if (creditRuleDetail.ruleKey == that.key4.key) {
              that.key4.id = creditRuleDetail.uuid;
              that.key4.value = creditRuleDetail.ruleValue;
            } else if (creditRuleDetail.ruleKey == that.key5.key) {
              that.key5.id = creditRuleDetail.uuid;
              that.key5.value = creditRuleDetail.ruleValue;
            }
          });
        }
      });
    },
    reset() {
      this.$confirm(`确认重置表单吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs["coverUpload"].clearFiles();
          this.$refs["ruleForm"].resetFields();
        })
        .catch(() => {});
    },
    onSubmit() {
      if (this.key1.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key1.id,
          ruleId: that.edituuid,
          ruleKey: that.key1.key,
          ruleValue: that.key1.value
        });
      }
      if (this.key2.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key2.id,
          ruleId: that.edituuid,
          ruleKey: that.key2.key,
          ruleValue: that.key2.value
        });
      }
      if (this.key3.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key3.id,
          ruleId: that.edituuid,
          ruleKey: that.key3.key,
          ruleValue: that.key3.value
        });
      }
      if (this.key4.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key4.id,
          ruleId: that.edituuid,
          ruleKey: that.key4.key,
          ruleValue: that.key4.value
        });
      }
      if (this.key5.value != null) {
        let that = this;
        this.ruleForm.creditRuleDetails.push({
          uuid: that.key5.id,
          ruleId: that.edituuid,
          ruleKey: that.key5.key,
          ruleValue: that.key5.value
        });
      }
      this.$confirm(`确认提交吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          creditRuleUpdate(this.ruleForm).then(res => {
            if (!res || res.code != 0) {
              this.$refs["ruleForm"].resetFields();
              throw new Error(res.msg);
            }
            this.$message.success(res.msg);
            this.$router.back();
            this.$refs["ruleForm"].resetFields();
          });
        })
        .catch(() => {});
    },
    cancel() {
      this.$router.back();
      this.$refs["ruleForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  background-color: #ffffff;
  height: 100%;

  .title {
    padding: 0 32px;
    height: 68px;
    line-height: 68px;
    color: #333333;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
    box-sizing: border-box;
  }

  .content {
    padding: 32px;

    /deep/ .el-form-item__label {
      font-size: 14px;
      color: #51627d;
    }
  }
}

.img_tip {
  font-size: 12px;
  color: #666;
}

$textColor: #51627d;
$textSize: 14px;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 104px;
  height: 104px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 84px;
  height: 84px;
  line-height: 84px;
  text-align: center;
}

.avatar {
  width: 104px;
  height: 104px;
  display: block;
}

.upload-text {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: $textColor;
  font-size: 13px;
}
</style>
